<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <!-- {{to_add_modules}}<hr>{{org_modules}} -->

        <v-row justify="center">
            <v-col class="d-flex" cols="2" sm="2"> </v-col>
            <v-col cols="6" sm="6">
                <v-select :items="to_add_modules" :hint="'For example :: Role-Management, Account'" v-model="to_add_modules" item-value="to_add_modules" label="Module"></v-select>
            </v-col>
            <v-col class="d-flex" cols="2" sm="2">
                <!-- <v-btn color="blue darken-1" text @click="close">Cancel</v-btn> -->
                <v-btn color="brand darken-1 white--text" @click="save(to_add_modules)"><v-icon>mdi-plus-circle</v-icon> Add</v-btn>
            </v-col>
        </v-row>

        <v-simple-table v-if="org_modules != null" cols="12">
            <template v-slot:default>
                <thead>
                    <tr>
                        <td colspan="6" class="centered-input">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details class="centered-input" style="width: 50%; margin: 0 auto;"></v-text-field>
                        </td>
                    </tr>
                    <br />
                    <tr>
                        <th class="text-left">SrNo.</th>
                        <th class="text-left">Module</th>
                        <th class="text-left">Icon</th>
                        <th class="text-left">Copy Icon Link</th>
                        <th class="text-left">Add/Edit Icon</th>
                        <th class="text-left">Activated</th>
                        <th class="text-left">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in filteredModules" :key="item.id">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.name }}</td>
                        <td>
                            <div justify="center" v-if="item.icon">
                                <v-img style="width: 110px; height: 75px;" class="shrink mr-2" contain :src="item.icon"></v-img>
                            </div>
                            <div v-else>-</div>
                        </td>
                        <td>
                            <span v-if="item.icon"><v-icon class="icon-quick" title="Copy The Icon Link" @click="copy(item.icon)">mdi-content-copy</v-icon></span>
                        </td>
                        <td><v-btn color="brand darken-1 white--text" @click="updateIcon(item.icon,item.id)">Add</v-btn></td>
                        <td>
                            <span v-if="item.isactive">
                                <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                            </span>
                            <span v-else>
                                <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                            </span>
                        </td>
                        <td>
                            <v-switch inset v-model="item.isactive" :color="item.isactive?'success':'primary'" @change="toggle(item)"></v-switch>
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>

        <v-dialog v-if="dialog_edit" v-model="dialog_edit" max-width="1000px">
            <v-card>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="8" md="8">
                                <p><b>Add/Update Icon</b></p>
                                <v-text-field v-model="icon_link" rounded outlined dense></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                            <v-btn class="button" @click="saveUpdateIcon()" :loading="loader">Update</v-btn>
                            <v-btn class="button" @click="dialog_edit = false">Close</v-btn>
                        </v-row>
                    </v-card>
                </v-col>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import axios from "axios";
    import { ok } from "assert";
    export default {
        data: () => ({
            snackbar_msg: "",
            color: "",
            snackbar: false,

            items: [],
            to_add_modules: null,
            org_modules: null,
            search: "",
            dialog_edit: false,
            icon_link: "",
            role_type_id: "",
        }),
        computed: {
            filteredModules() {
                if(!this.search) {
                    return this.org_modules;
                }

                return this.org_modules.filter(module =>
                    module.name.toLowerCase().includes(this.search.toLowerCase())
                );
            }
        },
        methods: {
            copy(link) {
                navigator.clipboard.writeText(link);
                alert("Link copied to clipboard!!!");
            },
            saveUpdateIcon() {
                const mod = {
                    icon_link: this.icon_link,
                    role_type_id: this.role_type_id,
                };
                axios
                    .post("/home/saveUpdateIcon", mod)
                    .then((res) => {
                        this.org_modules = res.data.org_modules;
                        this.showSnackbar("#4caf50", "Module Icon Updated Successfully..."); // show snackbar
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        (this.dialog_edit = false), (this.icon_link = ""), (this.role_type_id = "");
                    });
            },
            updateIcon(icon_link, role_type_id) {
                (this.icon_link = icon_link), (this.role_type_id = role_type_id);
                this.dialog_edit = true;
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            toggle(module) {
                const mod = {
                    moduleid: module.id,
                };
                axios
                    .post("/home/togglemodules", mod)
                    .then((res) => {
                        this.org_modules = res.data.org_modules;
                        this.showSnackbar("#4caf50", "Module Activation status has been updated."); // show snackbar
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        //overlay->loader
                    });
            },
            initcall() {
                axios
                    .get("/home/getmodules")
                    .then((res) => {
                        this.to_add_modules = res.data.to_add_modules;
                        this.org_modules = res.data.org_modules;
                    })
                    .catch((error) => {})
                    .finally(() => {
                        //overlay->loader
                    });
            },
            save(to_add_modules) {
                const mod = {
                    module: to_add_modules,
                };
                //moduleiiii : Object.assign({}, to_add_modules),
                //module:to_add_modules
                axios
                    .post("/Home/activatemodules", mod)
                    .then((res) => {
                        // if (res.data.status.action == "NA") {
                        this.org_modules.push(mod);
                        //window.alert("1");
                        this.initcall();
                        //window.alert('2')
                        this.showSnackbar("#4caf50", "Module added Successfully"); // show snackbar on success
                        //window.alert('3')
                        // }
                        // else if(res.data.status.action == "SUCCESS"){
                        //     window.alert(res.data.status.code)
                        //     this.showSnackbar("#b71c1c", "SUCCESS"); // show snackbar on error
                        // }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        window.alert("not added!");
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    });
            },
        },
        mounted() {
            this.initcall();
        },
    };
</script>

<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
</style>
